function initLandingNavbar() {
  const toggle = document.querySelector("[data-mobile-nav-toggle]")
  const dialog = document.querySelector("[data-mobile-nav-dialog]")
  const closeBtn = document.querySelector("[data-mobile-nav-close]")

  if (!toggle || !dialog) return

  toggle.addEventListener("click", () => {
    if (typeof dialog.showModal === "function") {
      dialog.showModal()
    }
  })

  closeBtn?.addEventListener("click", () => dialog.close())

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close()
  })

  dialog.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", () => dialog.close())
  })
}

document.addEventListener("DOMContentLoaded", initLandingNavbar)